const T = require("react").PropTypes;

const Question = require("./Question.js");

const Error = require("~/types/Error.js").PropType;

const Section = {
    /* For now, we only include props that we're actually using */
    PropType: T.shape({
        DisplayOrder: T.number,
        GUID: T.string.isRequired,
        IncludeNumberInHeader: T.bool,
        TitleHTML: T.string,
        Questions: T.arrayOf(Question.PropType),
        IsSaving: T.bool,
        SaveError: Error,
        // For summaries
        Score: T.number,
        MaxScore: T.number
    }),
    QuestionsDiffer(section, questionSnapshot) {
        const result = section.Questions.some((q, i) => {
            const otherQ = questionSnapshot[i];

            if (q.AnswerSelections.length !== otherQ.AnswerSelections.length) {
                return true;
            }

            const selectionsChanged = q.AnswerSelections.some((s, j) => {
                const propSelection = otherQ.AnswerSelections[j];

                const changed = s.SelectionText != propSelection.SelectionText;
                
                return changed;
            });

            const commentChanged = q.AdditionalComment != otherQ.AdditionalComment;

            const taskChanged = q.Task != otherQ.Task; 

            return commentChanged || selectionsChanged || taskChanged;
        });

        return result;
    }
};

module.exports = Section;


// WEBPACK FOOTER //
// ./src/types/Section.js